<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation per mobile -->
<ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation class="bg-card text-primary print:hidden w-full" [mode]="'over'" [name]="'mainNavigation'"
        [navigation]="navMenu" [opened]="false">
        <ng-container fuseVerticalNavigationContentHeader>
            <app-logo-comune></app-logo-comune>
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>


<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0"  #page>

    <!-- Primo Header -->
    <!-- <div class="flex flex-0 content-center justify-between items-center w-full h-12 sm:h-12 xl:px-80 md:px-20 sm:px-3 z-49 shadow dark:shadow-none dark:border-b bg-[#002e57] dark:bg-transparent print:hidden"  id="top">
        <div>
            <a class="text-white text-md font-light font-sans hover:underline cursor-pointer"
                href="https://www.regione.liguria.it/">Regione Liguria</a>
        </div>
        <user></user>
    </div> -->
<!--
    <div
        class="flex flex-0 content-center justify-between items-center w-full h-30 md:h-30 sm:h-20 xl:px-80 md:px-24 sm:px-3 z-49 shadow dark:shadow-none bg-primary dark:bg-transparent print:hidden">

    </div> -->

    <app-header-rapallo></app-header-rapallo>

    <!-- Content -->
    <div class="flex flex-col min-w-0 h-max-full bg-card" >
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <app-breadcrumb></app-breadcrumb>


        <router-outlet *ngIf="true"></router-outlet>

    </div>

    <div class="flex w-full h-full place-content-center bg-primary">
        <div class="my-10">
            <app-stepper-rating ></app-stepper-rating>
        </div>
    </div>

    <app-footer-rapallo></app-footer-rapallo>

</div>

